// Wire value → i18n key SEGMENT. Pure mapping, no copy.
//
// Wire vocabularies cannot be used as key segments as-is:
//   • statuses (`pending_approval`), payload fields (`daily_budget`) and error codes
//     (`GUARDRAIL_VIOLATION`) are snake/SCREAMING_SNAKE, while `key-format-style` requires
//     camelCase in per-feature bundles (only the reserved `errors.*.json` is exempt);
//   • action types additionally contain a `.`, which vue-i18n resolves as a PATH separator —
//     `actionType['campaign.budget_update']` would be looked up as
//     `actionType → campaign → budget_update` and never resolve.
// So statuses/fields/codes go through the mechanical camelizer, and action types through an
// explicit map (their dot cannot be camelized away meaningfully).

const ACTION_TYPE_KEYS: Record<string, string> = {
  'ad.create': 'adCreate',
  'ad.status_update': 'adStatusUpdate',
  'ad_set.bid_strategy': 'adSetBidStrategy',
  'ad_set.bid_update': 'adSetBidUpdate',
  'ad_set.budget_update': 'adSetBudgetUpdate',
  'ad_set.create': 'adSetCreate',
  'ad_set.schedule_update': 'adSetScheduleUpdate',
  'ad_set.spend_cap': 'adSetSpendCap',
  'ad_set.status_update': 'adSetStatusUpdate',
  'ad_set.targeting_update': 'adSetTargetingUpdate',
  'adgroup.bid_update': 'adgroupBidUpdate',
  'adgroup.budget_update': 'adgroupBudgetUpdate',
  'adgroup.negative_add': 'adgroupNegativeAdd',
  'adgroup.negative_remove': 'adgroupNegativeRemove',
  'adgroup.status_update': 'adgroupStatusUpdate',
  'campaign.bid_strategy': 'campaignBidStrategy',
  'campaign.budget_update': 'campaignBudgetUpdate',
  'campaign.create': 'campaignCreate',
  'campaign.schedule_update': 'campaignScheduleUpdate',
  'campaign.spend_cap': 'campaignSpendCap',
  'campaign.status_update': 'campaignStatusUpdate',
  'keyword.add': 'keywordAdd',
  'keyword.negative_add': 'keywordNegativeAdd',
  'keyword.negative_remove': 'keywordNegativeRemove',
  'keyword.remove': 'keywordRemove',
  'keyword.status_update': 'keywordStatusUpdate',
}

/** `pending_approval` / `GUARDRAIL_VIOLATION` → `pendingApproval` / `guardrailViolation`. */
export function camelKey(value: string): string {
  return value
    .toLowerCase()
    .replace(/[_-]([a-z0-9])/gu, (_, character: string) => character.toUpperCase())
}

/** `campaign.budget_update` → `budgetUpdate`; an unregistered type falls back to `unknown`. */
export function actionTypeKey(actionType: string): string {
  return ACTION_TYPE_KEYS[actionType] ?? 'unknown'
}

/** Every registered action type, for the propose form's select. */
export const ACTION_TYPE_KEY_ENTRIES = Object.entries(ACTION_TYPE_KEYS) as [string, string][]
